import { render } from "./Step5.vue?vue&type=template&id=5f8f40e1&scoped=true"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"

import "./Step5.vue?vue&type=style&index=0&id=5f8f40e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f40e1"]])

export default __exports__